const reducer = (state, action) => {
  switch (action.type) {
    case 'GET': {
      const { items } = action.data;
      const totalItems = items.reduce(
        (totalItems, item) => totalItems + item.quantity,
        0,
      );
      const { amount } = action.data;
      const { isOpened } = action.data;

      return {
        ...state,
        items,
        totalItems,
        amount,
        isOpened,
      };
    }
    case 'SET_OPEN_CART': {
      return {
        ...state,
        isOpened: action.data,
      };
    }
    case 'SET_TOTAL_ITEMS': {
      return {
        ...state,
        totalItems: action.data,
      };
    }
    default:
      throw new Error('Action type must be defined');
  }
};

export default reducer;
